// extracted by mini-css-extract-plugin
export default {"list":"QuoteList_list__MLz6k","sorting":"QuoteList_sorting__GDrEn"};